<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title" v-if="getModalData.id">Edit Organ system</div>
      <div class="title" v-else>Add Organ system</div>
    </div>
    <v-slick
      ref="slick"
      class="popup__typesetting mt-4"
      :options="slickOptions"
    >
      <div
        class="popup__language"
        v-for="item of getLangOptions"
        :class="{ active: item.value == lang }"
        @click="lang = item.value"
      >
        <img
          :src="'/img/lang/' + item.value + '.png'"
          :alt="item.label"
          class="popup__pennant"
        />
        <div class="popup__language-name">{{ item.label }}</div>
      </div>
    </v-slick>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form__bent">
        <label class="form__label">Name</label>
        <input type="text" class="form__field" v-model="form.name[lang]" />
      </div>
      <div class="form__bent">
        <label class="form__label">Description</label>
        <input
          type="text"
          class="form__field"
          v-model="form.description[lang]"
        />
      </div>
      <div class="form__bent">
        <label class="form__label">Symptoms</label>
        <textarea
          class="form__field"
          @input="onChangeSymptoms"
          v-model="textareaSymptoms"
        ></textarea>
      </div>
      <div class="form__btn">
        <button class="btn" type="submit" v-if="getModalData.id">Save</button>
        <button class="btn" type="submit" v-else>Add</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalOrganSystem",
  data() {
    return {
      lang: "en",
      form: {
        name: {},
        description: {},
        symptoms: {},
      },
      textareaSymptoms: "",
      slickOptions: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getLangOptions", "getModalData"]),
    // textareaSymptoms() {
    //   if (this.form.symptoms[this.lang] == 'undefined' || this.form.symptoms[this.lang] == null || !Array.isArray(this.form.symptoms[this.lang]))
    //     return ''
    //   return this.form.symptoms[this.lang].join('\n')
    // }
  },
  mounted() {
    if (this.getModalData.id) {
      this.form = {
        name: this.getModalData.name,
        description: this.normalizeLocaleData(this.getModalData.description),
        symptoms: this.getModalData.symptoms,
      };
      if (
        this.form.symptoms[this.lang] == "undefined" ||
        this.form.symptoms[this.lang] == null ||
        !Array.isArray(this.form.symptoms[this.lang])
      )
        this.textareaSymptoms = "";
      else
        this.textareaSymptoms = this.getModalData.symptoms[this.lang].join(
          "\n",
        );
    }
  },
  watch: {
    lang(val) {
      console.log(this.form.symptoms[val]);
      if (
        this.form.symptoms[val] == "undefined" ||
        this.form.symptoms[val] == null ||
        !Array.isArray(this.form.symptoms[val])
      )
        this.textareaSymptoms = "";
      else this.textareaSymptoms = this.getModalData.symptoms[val].join("\n");
    },
  },
  methods: {
    ...mapActions(["storeOrganSystem", "updateOrganSystem"]),
    normalizeLocaleData(value) {
      if (!value) return {};
      if (typeof value === "object") return value;
      if (typeof value !== "string") return {};

      try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" ? parsed : {};
      } catch (e) {
        return {};
      }
    },
    onSubmit() {
      if (this.getModalData.id)
        this.updateOrganSystem([this.getModalData.id, this.form]);
      else this.storeOrganSystem(this.form);
    },
    onChangeSymptoms(event) {
      this.form.symptoms[this.lang] = event.target.value.split("\n");
    },
  },
};
</script>

<style scoped>
.popup {
  padding: 50px 100px !important;
}
</style>
